module.exports = __webpack_public_path__ + "media/src/assets/Images/NotificationRed-eb9b8b8ad492d4f80d3cf127fae7b9f0.svg";